import { NordEvent } from '../common/events.js'

/** The payload carried by a {@link DateRangeChangeEvent}. */
export interface DateRangeChangeDetail {
  /** The committed interval string `YYYY-MM-DD/YYYY-MM-DD`, or `""` when empty. */
  value: string
  /** The committed start date in ISO-8601 format, or `""` when empty. */
  startDate: string
  /** The committed end date in ISO-8601 format, or `""` when empty. */
  endDate: string
}

/**
 * Dispatched by `nord-date-range-picker` when the committed range changes. The
 * live `input` event uses this same shape, while `change` is dispatched once the
 * pending selection is applied (or cleared).
 */
export class DateRangeChangeEvent extends NordEvent {
  constructor(
    name: string,
    private readonly _detail: DateRangeChangeDetail,
  ) {
    super(name)
  }

  /** Convenience accessor mirroring `CustomEvent.detail`. */
  get detail(): DateRangeChangeDetail {
    return this._detail
  }

  /** The committed interval string `YYYY-MM-DD/YYYY-MM-DD`, or `""`. */
  get value(): string {
    return this._detail.value
  }

  /** The committed start date in ISO-8601 format, or `""`. */
  get startDate(): string {
    return this._detail.startDate
  }

  /** The committed end date in ISO-8601 format, or `""`. */
  get endDate(): string {
    return this._detail.endDate
  }
}
